import {memo} from 'react';

import styled, {css} from 'styled-components';

import {flexColumn} from '~/shared/theme/FlexLayout';
import {PriceLabel, PriceLabelWithStrikethrough} from '~/shared/components/PriceLabels';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {getDishPriceWithDiscount} from '~/shared/utils/priceDiscountCalculator';
import {Coupon} from '~/shared/store/models';
import {bodyBold, captionRegular} from '~/shared/theme/typography';

const columnStyles = css`
  ${flexColumn}
  justify-content: center;
  align-items: flex-end;
`;

const Price = styled(PriceLabel)<{noMargin?: boolean; bold?: boolean}>`
  font-weight: ${({bold}) => (bold ? 'bold' : 'normal')};
  line-height: 18px;
  ${({noMargin}) => !noMargin && flipOnLTR`
     margin-right: auto;
  `}
`;

const inlineStyles = css`
  flex-direction: row-reverse;
  align-items: center;
  gap: 3px;

  ${Price} {
    ${bodyBold}
  }

  ${PriceLabelWithStrikethrough} {
    ${captionRegular}
    line-height: 12px;
    color: ${({theme}) => theme.colors.surface};
  }
`;

const PriceLabelWithDiscountContainer = styled.div<{inline?: boolean}>`
  display: flex;
  ${({inline}) => (inline ? inlineStyles : columnStyles)}
`;

type PriceLabelWithDiscountProps = {
  price: number;
  currentCoupon: Coupon | null;
  bold?: boolean;
  inline?: boolean;
};

const PriceLabelWithDiscount = ({price, currentCoupon, bold, inline}: PriceLabelWithDiscountProps) => {
  const discountData = getDishPriceWithDiscount(price, currentCoupon);

  if (!discountData) {
    return (
      <Price price={price} priceDataTestId="dishPrice" bold={bold} />
    );
  }

  return (
    <PriceLabelWithDiscountContainer inline={inline}>
      <Price price={discountData.priceAfterDiscount} priceDataTestId="dishPriceAfterdiscount" noMargin bold={bold} />
      <PriceLabelWithStrikethrough price={discountData.price} priceDataTestId="dishPrice" grey noMargin />
    </PriceLabelWithDiscountContainer>
  );
};

export default memo(PriceLabelWithDiscount);
